import { ReactNode } from 'react';

import { Box, Typography } from '@material-ui/core';

import { useStyles } from './styles';

interface Props {
  label: string;
  /** One plain sentence under the label, for groups that need explaining before the cards. */
  description?: string;
  children: ReactNode;
}

/** A titled group of settings cards, e.g. "Hours & pay rules". */
export const SettingsSection = ({ label, description, children }: Props) => {
  const classes = useStyles();

  return (
    <Box className={classes.section}>
      <Box className={classes.sectionHeader}>
        <Typography className={classes.sectionLabel}>{label}</Typography>

        {!!description && (
          <Typography variant="caption" className={classes.sectionDescription}>
            {description}
          </Typography>
        )}
      </Box>

      <Box className={classes.sectionCards}>{children}</Box>
    </Box>
  );
};

/** Two cards side by side, stacking to one column on narrow screens. */
export const SettingsCardPair = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();

  return <Box className={classes.pair}>{children}</Box>;
};
